import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import IconArrow from "@/assets/icons/icon__arrow.svg";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'BtnLink',
  props: {
    name: {},
    path: {},
    href: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.path)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: _ctx.path,
        class: "btn btn--icon-translate-hover"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
          _createVNode(_unref(IconArrow), { class: "icon" })
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.href,
          target: "_blank",
          class: "btn btn--icon-translate-hover"
        }, [
          _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
          _createVNode(_unref(IconArrow), { class: "icon" })
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
}
}

})